import { Action } from 'redux';
import {
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_ERROR,
  SELECT_INGREDIENT,
  RESET,
} from './actions';

export enum AiChefTypeEnum {
  meal = 'meal',
  ingredient = 'ingredient',
  unknown = 'unknown',
  all = 'all',
}

export interface Data {
  id: number;
  name: string;
  description: string;
}

export interface IAiImgRequest {
  url: string;
}

export interface IRecipe {
  id: number;
  lang_id: number;
  name: string;
  thumbnail: string;
  video_id: string;
  content: string;
  created_at: string;
  updated_at: string;
}

export interface IIngredient {
  id: number;
  name: string;
  responses: Array<{
    id: number;
    pivot: {
      content: string;
      recipe_request_id: number;
      reference_id: number;
    }
  }>;
}

export interface IAiImgResponse {
  request_id: number;
  title: string;
  type: AiChefTypeEnum;
  data: {
    ingredient: IIngredient[];
    meal: IRecipe[];
  };
}

export interface FetchDataRequestAction extends Action<typeof FETCH_DATA_REQUEST> {
  payload: IAiImgRequest
}

export interface FetchDataSuccessAction extends Action<typeof FETCH_DATA_SUCCESS> {
  payload: IAiImgResponse;
}

export interface FetchDataErrorAction extends Action<typeof FETCH_DATA_ERROR> {
  payload: Error;
}

export interface SelectIngredientAction extends Action<typeof SELECT_INGREDIENT> {
  payload: any[];
}

export interface ResetAction extends Action<typeof RESET> {
  payload: boolean;
}
